import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { IUserListingModel } from '../../models/user';

@Component({
    template: require('./template.html')
})
class UserResourceComponent extends Vue {
    dtSettingIsLoading: boolean;


    @Prop({ default: () => [], type: Array })
    dataSource: IUserListingModel[];

    @Prop({ default: () => [], type: [Array], required: true })
    destination: number[];

    @Prop({ default: () => [], type: [Array] })
    dataChanged: any;

    @Prop({ default: () => [], type: [Array] })
    disableWith: number[];

    @Prop({ default: false, type: [Boolean] })
    collapTags: boolean;

    @Prop({ default: false, type: [Boolean] })
    remoteLoading: boolean;

    @Prop({ default: false, type: [Boolean] })
    disabled: boolean;


    constructor() {
        super();
        this.dtSettingIsLoading = true;

    }

    get isCollapseTags(): boolean {
        return this.collapTags;
    }
    get coDisableWith(): number[] {
        return this.disableWith;
    }
    get coUsers(): IUserListingModel[] {
        return this.dataSource;
    }
    get coDetination(): number[] {
        return this.destination;
    }
    set coDetination(value: number[]) {
        this.$emit('update:destination', value);
    }
    mounted() {
    }
    @Emit('change')
    handleChange() {
    }
    @Emit('blur')
    handleBlur(){
    }
    checkDisabled(id: number): boolean {
        if (this.coDisableWith === undefined) return false;
        return this.coDisableWith.indexOf(id) > -1;
    }

}
export default UserResourceComponent;